<script>
import isFunction from 'lodash/isFunction';
import CompanyModel from '@models/Company';
import ContactModel from '@models/Contact';
import VipModel from '@models/Vip';
import LocationModel from '@models/Location';
import ParamModel from '@models/Param';
import QuoteModel from '@models/Quote';
import UniversalModel from '@models/Universal';
import AdminModel from '@models/Admin';
import BlockingContainer from '@components/BlockingContainer';
import editFormChange from '@mixins/editFormChange';
import utility from '@mixins/utility';
import ContactMultiselect from '@components/ContactMultiselect';
import EntityMultiselect from '@components/EntityMultiselect';
import AdminMultiselect from '@/src/components/AdminMultiselect';
import cloneDeep from 'lodash/cloneDeep';
import { mapState } from 'vuex';
import flatPickr from 'vue-flatpickr-component';
import datePickerUtility from '@mixins/datePickerUtility';
import ContactForm from '@views/contacts/form';
import CompanyForm from '@views/companies/form'
import QuoteVersionHistory from '@components/QuoteVersionHistory';
import LocationForm from '@views/locations/form';
import { quillEditor } from 'vue-quill-editor';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
export default {
  components: {
    BlockingContainer,
    ContactMultiselect,
    EntityMultiselect,
    AdminMultiselect,
    flatPickr,
    ContactForm,
    CompanyForm,
    QuoteVersionHistory,
    quillEditor,
    LocationForm,
    FontAwesomeIcon,
  },
  mixins: [editFormChange, datePickerUtility, utility],
  props: {
    // eslint-disable-next-line
    loadedId: {
      default: null,
    },
    quoteId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      companyModel: CompanyModel,
      vipModel: VipModel,
      locationModel: LocationModel,
      contactModel: ContactModel,
      adminModel: AdminModel,
      showContactModal: false,
      showCompanyModal: false,
      showVipModal: false,
      showCreateLocationModal: false,
      showAddNotes: false,
      showAddCancellationPolicy: false,
      showAddPaymentTerms: false,
      default_notes_de: '<ul><li>Die Zusatzstunde wird mit € 50,00 berechnet.</li><li>Sämtliche Nebenkosten (z.B. Benzin, Parken, Maut) werden netto nach tatsächlichem Aufwand berechnet.</li><li>Die kalkulierten Einsatzzeiten beinhalten 1h für An- und Abfahrt.</li><li>Alle genannten Preise verstehen sich zzgl. 19% USt.</li></ul>',
      default_notes_en: '<ul><li>Additional hours will be charged at € 50,00 per hour.</li><li>Vehicle running costs (gas, parking, toll) will be added at net cost price</li><li>Calculated service times include 1 hour for approach &amp; return.</li><li>All prices are subject to German VAT (19%).</li></ul>',
      default_cancellation_policy_de: '<ul><li>bis 3 Tage vor Auftragsbeginn 10% des vereinbarten Preises</li><li>bis 2 Tage vor Auftragsbeginn 20% des vereinbarten Preises</li><li>bis 1 Tag vor Auftragsbeginn 50% des vereinbarten Preises</li><li>am Tage des Auftragsbeginns 80% des vereinbarten Preises</li></ul>',
      default_cancellation_policy_en: '<ul><li>up to 3 days before start of assignment: 10% of the agreed price</li><li> up to 2 days before start of assignment: 20% of the agreed price</li><li>up to 1 day before start of assignment: 50% of the agreed price</li><li>same day of start of assignment: 80% of the agreed price</li></ul>',
      default_payment_terms_de: '<ul><li>zahlbar innerhalb von 14 Tagen nach Rechnungsstellung</li><li>bei Kartenzahlung wird ein Aufschlag von 3% erhoben</li></ul>',
      default_payment_terms_en: '<ul><li>payable within 14 days of invoice date</li><li>payments by card will incur a 3% surcharge</li></ul>',
      quote: {
        id: null,
        vip_id: null,
        location_id: null,
        contact_not_in_company: false,
        company_id: null,
        contact_id: null,
        organizer_id: null,
        language: 'de',
        date: null,
        notes: null,
        cancellation_policy: null,
        payment_terms: null,
        add_tax: 1,
        organizer: null,
        company: null,
        contact: null,
        vip: null,
        location: null,
      },
      vip: {
        entity: 'Vip',
        name: '',
      },
      languageOptions: [
        { value: 'de', text: this.$t('fields.german') },
        { value: 'en', text: this.$t('fields.english') },
      ],
      areas: [],
    };
  },
  computed: {
    ...mapState({
      dateOnlyConfig: (state) => state.common.dateOnlyConfig,
      currentUser: (state) => state.auth.user,
      quillOptions: (state) => state.common.quillOptions,
    }),
    contactNotInCompanyDisabled() {
      return this.quote.company_id == null;
    },
    whereCompanyId() {
      return this.quote.contact_not_in_company ? null : this.quote.company_id;
    },
  },
  watch: {
    showAddNotes(newVal) {
      if (!newVal) {
        this.quote.notes = null;
      } else {
        if(this.quote.notes == null || this.quote.notes === '') {
          if(this.quote.language === 'de') {
            this.quote.notes = this.default_notes_de;
          } else {
            this.quote.notes = this.default_notes_en;
          }
        }
      }
    },
    showAddCancellationPolicy(newVal) {
      if (!newVal) {
        this.quote.cancellation_policy = null;
      } else {
        if(this.quote.cancellation_policy == null || this.quote.cancellation_policy === '') {
          if(this.quote.language === 'de') {
            this.quote.cancellation_policy = this.default_cancellation_policy_de;
          } else {
            this.quote.cancellation_policy = this.default_cancellation_policy_en;
          }
        }
      }
    },
    showAddPaymentTerms(newVal) {
      if (!newVal) {
        this.quote.payment_terms = null;
      } else {
        if(this.quote.payment_terms == null || this.quote.payment_terms === '') {
          if(this.quote.language === 'de') {
            this.quote.payment_terms = this.default_payment_terms_de;
          } else {
            this.quote.payment_terms = this.default_payment_terms_en;
          }
        }
      }
    },
  },
  mounted() {
    // fetch areas
    (new ParamModel).params({
          select_many: ['areas'].join(','),
        }).first()
    .then((response) => {
      this.areas = response.areas;
    });

    this.loadData();
  },
  methods: {
    async loadData() {
      if (this.loadedId) {
        this.$wait.start('quote loading');
        QuoteModel.find(this.loadedId).then((response) => {
          this.quote = cloneDeep(response.quote);
          this.$wait.end('quote loading');
          this.$nextTick(() => {
            this.initChangeWatcher(['quote'], this.validate);
            this.setToggleData();
          });
        });
      } else {
        // set admin as default organizer
        this.quote.organizer = this.currentUser;
        this.quote.organizer_id = this.currentUser.id;
        // Set current date for new quotes
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        this.quote.date = `${year}-${month}-${day}`;
      }
    },
    setToggleData() {
      this.showAddNotes = this.quote.notes !== null && this.quote.notes !== '';
      this.showAddCancellationPolicy = this.quote.cancellation_policy !== null && this.quote.cancellation_policy !== '';
      this.showAddPaymentTerms = this.quote.payment_terms !== null && this.quote.payment_terms !== '';
    },
    reloadVersions() {
      // Reload version history when positions are changed
      if (this.$refs.versionHistory) {
        this.$refs.versionHistory.loadVersions();
      }
    },
    resetFields() {
      this.quote.vip_id = null;
      this.quote.company_id = null;
      this.quote.contact_id = null;
      this.quote.organizer_id = null;
      this.quote.date = null;
      this.quote.invoice_number = [];
      this.quote.language = null;
      this.quote.notes = null;
      this.quote.cancellation_policy = null;
      this.quote.payment_terms = null;
      this.quote.add_tax = 1;
    },
    validate(callback) {
      this.$validator.validateAll('quote-form').then((result) => {
        if (result) {
          this.$wait.start('quote loading');
          this.submit(callback);
        }
      });
    },
    validateAndCreateVersion() {
      this.$validator.validateAll('quote-form').then((result) => {
        if (result) {
          this.$wait.start('quote loading');
          this.submitAndCreateVersion();
        }
      });
    },
    async deleteQuote() {
      if (confirm(this.$t('alerts.delete_entity', { entity: this.$t('entities.quote') }))) {
        this.$wait.start('quote processing');
        const id = this.loadedId;
        const quote = new QuoteModel({ id });
        await quote.delete();
        this.$wait.end('quote processing');
        window.close();
      }
    },
    submit(callback) {
      let data = {};

      if (this.$route.params.id && this.quoteId == null) {
        data.id = this.$route.params.id;
      }

      if (this.quoteId) {
        data.id = this.quoteId;
        callback = this.resetFields;
      }

      data.company_id = this.quote.company_id;
      data.vip_id = this.quote.vip_id;
      data.location_id = this.quote.location_id;
      data.contact_id = this.quote.contact_id;
      data.organizer_id = this.quote.organizer_id;
      data.date = this.quote.date;
      data.language = this.quote.language;
      data.notes = this.quote.notes;
      data.cancellation_policy = this.quote.cancellation_policy;
      data.payment_terms = this.quote.payment_terms;
      data.add_tax = this.quote.add_tax;

      new QuoteModel(data)
        .save()
        .then((response) => {
          this.$emit('submitted', response.quote);
          this.quote = cloneDeep(response.quote);
          this.$wait.end('quote loading');
          if (!callback) {
            this.$router.push({
              name: 'quotes.index',
            });
          } else if (isFunction(callback)) {
            callback();
          }
        })
        .catch(() => this.$wait.end('quote loading'));
    },
    submitAndCreateVersion() {
      // Only allow version creation for existing quotes
      if (!this.$route.params.id && !this.quoteId) {
        this.$toasted.error(this.$t('errors.quote_must_exist_for_versioning'));
        this.$wait.end('quote loading');
        return;
      }

      let data = {};

      if (this.$route.params.id && this.quoteId == null) {
        data.id = this.$route.params.id;
      }

      if (this.quoteId) {
        data.id = this.quoteId;
      }

      data.company_id = this.quote.company_id;
      data.vip_id = this.quote.vip_id;
      data.location_id = this.quote.location_id;
      data.contact_id = this.quote.contact_id;
      data.organizer_id = this.quote.organizer_id;
      data.date = this.quote.date;
      data.language = this.quote.language;
      data.notes = this.quote.notes;
      data.cancellation_policy = this.quote.cancellation_policy;
      data.payment_terms = this.quote.payment_terms;
      data.add_tax = this.quote.add_tax;

      this.$http
        .post(`admin/quotes/${data.id}/create-version`, data)
        .then((response) => {
          this.$emit('submitted', response.data.quote);
          this.quote = cloneDeep(response.data.quote);
          this.$wait.end('quote loading');
          // Reload versions
          this.reloadVersions();
          this.$toasted.success(this.$t('messages.version_created'));
        })
        .catch(() => this.$wait.end('quote loading'));
    },
    createVIP(event) {
      event.preventDefault();
      if (this.vip.name !== '') {
        this.$wait.start('global loading');
        new UniversalModel(this.vip)
          .save()
          .then((response) => {
            this.$wait.end('global loading');
            this.vipCreated(response.entity);
          })
          .catch(() => this.$wait.end('global loading'));
      }
    },
    contactCreated(contact) {
      this.quote.contact_id = contact.id;
      this.quote.contact = contact;
      this.showContactModal = false;
    },
    companyCreated(company) {
      this.quote.company_id = company.id;
      this.quote.company = company;
      this.showCompanyModal = false;
    },
    vipCreated(vip) {
      this.quote.vip = vip;
      this.quote.vip_id = vip.id;
      // reset vip
      this.vip.name = '';
      this.showVipModal = false;
    },
    closeLocationModal() {
      this.showCreateLocationModal = false;
    },
    locationCreated(location) {
      this.quote.location_id = location.id;
      this.quote.location = location;
      this.showCreateLocationModal = false;
    },    
  },
};
</script>

<template>
  <div>
    <BlockingContainer v-if="$wait.is('quote loading')"></BlockingContainer>
    
    <!-- Version History - Only show when editing existing quote -->
    <QuoteVersionHistory v-if="quote.id" ref="versionHistory" :quote="quote" />
    
    <b-form data-vv-scope="quote-form" @submit.prevent="validate">
      <b-form-group>
        <template v-slot:label class="col-form-legend col-12"> {{ $t('fields.date') }}:
        </template>
        <div :class="{ 'is-invalid': errors.has('date', 'quote-form') }">
          <flat-pickr
            v-model="quote.date"
            v-validate="''"
            data-vv-name="date"
            :data-vv-as="$t('fields.date')"
            aria-describedby="input-feedback-date"
            :config="dateOnlyConfig"
            class="form-control"
            :class="{ 'is-invalid': errors.has('date', 'quote-form') }"
            :placeholder="$t('placeholders.date')"
            @on-close="closeCalendar('quote.date', 'dd.MM.yyyy', 'yyyy-MM-dd', ...arguments)"
          >
          </flat-pickr>
          <b-form-invalid-feedback id="input-feedback-date">
            <template v-show="errors.has('date', 'quote-form')">{{ errors.first('date', 'quote-form') }} </template>
          </b-form-invalid-feedback>
        </div>
      </b-form-group>
      <b-form-group>
        <template v-slot:label class="col-form-legend col-12">
          {{ $t('fields.organizer') }}:
          <span class="status-star text-danger">*</span>
        </template>
        <AdminMultiselect
          v-model="quote.organizer_id"
          v-validate="'required'"
          data-vv-name="organizer"
          :data-vv-as="$t('fields.organizer')"
          :initial-value="quote.organizer"
          :state="errors.has('organizer_id')"
          :placeholder="$t('placeholders.organizer')"
          :model="adminModel"
        >
        </AdminMultiselect>
        <b-form-invalid-feedback id="input-feedback-organizer_id">
          <template v-show="errors.has('organizer_id')">{{ errors.first('organizer_id') }}</template>
        </b-form-invalid-feedback>
      </b-form-group>
      <b-row>
        <b-col sm="12">
          <b-form-group>
            <template v-slot:label class="col-form-legend col-12">
              {{ $t('fields.company') }}:
            </template>
            <b-input-group>
              <div class="multiselect-container form-control p-0 border-0">
                <EntityMultiselect
                  v-model="quote.company_id"
                  v-validate="''"
                  data-vv-name="company_id"
                  :data-vv-as="$t('fields.company')"
                  :initial-value="quote.company"
                  :state="errors.has('company_id')"
                  :placeholder="$t('placeholders.enter_at_least_three_letters')"
                  :model="companyModel"
                >
                </EntityMultiselect>
              </div>
              <b-input-group-append>
                <b-btn variant="secondary" class="w-100 text-white" @click="showCompanyModal = true">
                  <FontAwesomeIcon :icon="['fas', 'plus']" />
                </b-btn>
              </b-input-group-append>
            </b-input-group>
            <div v-show="errors.has('company_id')" class="invalid-feedback d-block m-0 mt-1">
              {{ errors.first('company_id') }}
            </div>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12">
          <b-form-group>
            <template v-slot:label>
              {{ $t('fields.contact') }}:&nbsp;
              <b-form-checkbox
                v-model="quote.contact_not_in_company"
                name="check-button"
                switch
                :value="true"
                :unchecked-value="false"
                :disabled="contactNotInCompanyDisabled"
                class="d-inline"
              >
                <span>{{ $t('fields.contact_not_in_company') }}</span>
              </b-form-checkbox>
            </template>
            <b-input-group>
              <div class="multiselect-container form-control p-0 border-0">
                <ContactMultiselect
                  v-model="quote.contact_id"
                  v-validate="''"
                  data-vv-name="contact_id"
                  :data-vv-as="$t('fields.contact')"
                  :initial-value="quote.contact"
                  :state="errors.has('contact_id')"
                  :placeholder="$t('placeholders.enter_at_least_three_letters')"
                  :company="whereCompanyId"
                  sort="first_name"
                >
                </ContactMultiselect>
              </div>
              <b-input-group-append>
                <b-btn class="w-100 text-white" variant="secondary" @click="showContactModal = true">
                  <FontAwesomeIcon :icon="['fas', 'plus']" />
                </b-btn>
              </b-input-group-append>
            </b-input-group>  
            <div v-show="errors.has('contact_id')" class="invalid-feedback d-block m-0 mt-1">
              {{ errors.first('contact_id') }}
            </div>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12">
          <b-form-group>
            <template v-slot:label class="col-form-legend col-12">
              {{ $t('fields.vip') }}:
            </template>
            <b-input-group>
              <div class="multiselect-container form-control p-0 border-0">
                <EntityMultiselect
                  v-model="quote.vip_id"
                  v-validate="''"
                  data-vv-name="vip_id"
                  :data-vv-as="$t('fields.vip')"
                  :initial-value="quote.vip"
                  :state="errors.has('vip_id', 'quote-form')"
                  :placeholder="$t('placeholders.enter_at_least_three_letters')"
                  :model="vipModel"
                >
                </EntityMultiselect>
              </div>
              <b-input-group-append>
                <b-btn variant="secondary" class="w-100 text-white" @click="showVipModal = true">
                  <FontAwesomeIcon :icon="['fas', 'plus']" />
                </b-btn>
              </b-input-group-append>
            </b-input-group>
            <div v-show="errors.has('vip_id', 'quote-form')" class="invalid-feedback d-block m-0">
              {{ errors.first('vip_id', 'quote-form') }}
            </div>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12">
          <b-form-group>
            <template v-slot:label class="col-form-legend col-12">
              {{ $t('fields.location') }}:
            </template>
            <b-input-group>
              <div class="multiselect-container form-control p-0 border-0">
                <EntityMultiselect
                  v-model="quote.location_id"
                  v-validate="''"
                  data-vv-name="location_id"
                  :data-vv-as="$t('fields.location')"
                  :initial-value="quote.location"
                  :state="errors.has('location_id', 'quote-form')"
                  :placeholder="$t('placeholders.enter_at_least_three_letters')"
                  :model="locationModel"
                >
                </EntityMultiselect>
              </div>
              <b-input-group-append>
                <b-btn variant="secondary" class="w-100 text-white" @click="showCreateLocationModal = true">
                  <FontAwesomeIcon :icon="['fas', 'plus']" />
                </b-btn>
              </b-input-group-append>
            </b-input-group>
            <div v-show="errors.has('location_id', 'quote-form')" class="invalid-feedback d-block m-0">
              {{ errors.first('location_id', 'quote-form') }}
            </div>
          </b-form-group>
        </b-col>
      </b-row>      
      <b-row>
        <b-col lg="4" sm="12">
          <b-form-group :label="`${$t('fields.language_version')}:`">
            <b-form-radio-group
              v-model="quote.language"
              buttons
              button-variant="outline-secondary border-gray"
              :options="languageOptions"
              class="executor-radio-group w-100"
            >
            </b-form-radio-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-form-group>
        <b-form-checkbox
          v-model="quote.add_tax"
          name="add-tax-check-button"
          switch
          :value="1"
          :unchecked-value="0"
          class="d-inline"
        >
          <span>{{ $t('fields.add_tax') }}</span>
        </b-form-checkbox>
        <b-form-invalid-feedback id="input-feedback-add_tax">
          <template v-show="errors.has('add_tax')">{{ errors.first('add_tax') }}</template>
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group>
        <b-form-checkbox
          v-model="showAddNotes"
          name="add-notes-check-button"
          switch
          :value="true"
          :unchecked-value="false"
          class="d-inline"
        >
          <span>{{ $t('fields.add_notes') }}</span>
        </b-form-checkbox>
      </b-form-group>
      <b-form-group v-if="showAddNotes">
        <quill-editor ref="notes" v-model="quote.notes" :options="quillOptions" />
        <b-form-invalid-feedback id="input-feedback-notes">
          <template v-show="errors.has('notes')">{{ errors.first('notes') }}</template>
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group>
        <b-form-checkbox
          v-model="showAddCancellationPolicy"
          name="add-cancellation-check-button"
          switch
          :value="true"
          :unchecked-value="false"
          class="d-inline"
        >
          <span>{{ $t('fields.cancellation_policy') }}</span>
        </b-form-checkbox>
      </b-form-group>
      <b-form-group v-if="showAddCancellationPolicy">
        <quill-editor ref="cancellation_policy" v-model="quote.cancellation_policy" :options="quillOptions" />
        <b-form-invalid-feedback id="input-feedback-cancellation_policy">
          <template v-show="errors.has('cancellation_policy')">{{ errors.first('cancellation_policy') }}</template>
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group>
        <b-form-checkbox
          v-model="showAddPaymentTerms"
          name="add-payment-check-button"
          switch
          :value="true"
          :unchecked-value="false"
          class="d-inline"
        >
          <span>{{ $t('fields.payment_terms') }}</span>
        </b-form-checkbox>
      </b-form-group>
      <b-form-group v-if="showAddPaymentTerms">
        <quill-editor ref="payment_terms" v-model="quote.payment_terms" :options="quillOptions" />
        <b-form-invalid-feedback id="input-feedback-payment_terms">
          <template v-show="errors.has('payment_terms')">{{ errors.first('payment_terms') }}</template>
        </b-form-invalid-feedback>
      </b-form-group>
      <b-button type="submit" :disabled="errors.any()" :variant="'outline-' + (!errors.any() ? 'dark' : 'danger')">
        {{ $t('actions.submit') }}
      </b-button>
      <b-button 
        v-if="loadedId" 
        type="button"
        :disabled="errors.any()" 
        :variant="'outline-' + (!errors.any() ? 'primary' : 'danger')" 
        class="ml-2"
        @click="validateAndCreateVersion"
      >
        {{ $t('actions.new_version') }}
      </b-button>
      <div class="float-right">
        <b-button v-if="loadedId" variant="outline-danger" class="ml-2" @click="deleteQuote">
          {{ $t('actions.delete') }}
        </b-button>
      </div>
    </b-form>
    <b-modal v-if="showContactModal" v-model="showContactModal" size="lg" hide-footer :title="$t('titles.create_contact')" static @hidden="$emit('hidden')">
      <ContactForm :company-id="quote.company_id" :is-modal="true" @submitted="contactCreated" />
    </b-modal>
    <b-modal v-if="showCompanyModal" v-model="showCompanyModal" size="lg" hide-footer :title="$t('titles.create_company')" static @hidden="$emit('hidden')">
      <CompanyForm :is-modal="true" @submitted="companyCreated" />
    </b-modal>
    <b-modal v-if="showVipModal" v-model="showVipModal" size="lg" hide-footer :title="$t('titles.create_vip')" static @hidden="$emit('hidden')">
      <b-form @submit="createVIP">
        <b-form-group>
          <template v-slot:label class="col-form-legend col-12">
            {{ $t('fields.name') }}:
            <span class="status-star text-danger">*</span>
          </template>
          <b-form-input
            id="name"
            v-model="vip.name"
            v-validate="'required|max:255'"
            data-vv-value-path="localValue"
            data-vv-name="name"
            :data-vv-as="$t('fields.name')"
            type="text"
            :state="errors.has('name') ? false : null"
            aria-describedby="input-feedback-name"
            :placeholder="$t('placeholders.name')"
          >
          </b-form-input>
          <b-form-invalid-feedback id="input-feedback-name">
            <template v-show="errors.has('name')">{{ errors.first('name') }}</template>
          </b-form-invalid-feedback>
          <b-button :disabled="vip.name === ''" type="submit" variant="outline-dark" class="mt-2">
            {{ $t('actions.submit') }}
          </b-button>
        </b-form-group>
      </b-form>
    </b-modal>
    <b-modal
      ref="location-modal"
      v-model="showCreateLocationModal"
      size="lg"
      hide-footer
      :title="$t('titles.create_location')"
      static
      @hide="closeLocationModal"
    >
      <div class="row">
        <div class="col">
          <LocationForm :areas="areas" :is-modal="true" @submitted="locationCreated" />
        </div>
      </div>
    </b-modal>
  </div>
</template>
<style lang="scss" scoped>
.input-group-append .btn {
  min-width: 80px;
}
</style>
